import { View } from "@react-pdf/renderer";
import { ResumePDFText, ResumePDFHighlightableText } from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateThreeEnhancedSection } from "./common";
import type { ResumeProfile } from "lib/redux/types";

export const Summary = ({
  profile,
  heading,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  profile: ResumeProfile;
  heading: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  const { summary } = profile;

  return (
    <TemplateThreeEnhancedSection heading={heading}>
      <View>{summary && ((enableHighlight || enableMistakeHighlight) ? (
        <ResumePDFHighlightableText
          text={summary}
          section="profile"
          itemIndex={null}
          enableMistakeHighlight={enableMistakeHighlight}
        />
      ) : (
        <ResumePDFText>{summary}</ResumePDFText>
      ))}</View>
    </TemplateThreeEnhancedSection>
  );
};
